import React from 'react';
import PropTypes from 'prop-types';
import {
  sortBy,
  filter,
} from 'lodash';
import {
  Grid,
  withStyles,
  Card,
  CardContent,
} from '@material-ui/core';

import styles from './styles';
import TagTypeEditor from '../TagTypeEditor';
import TagTree from '../TagTree';

export class TagTypeListComponent extends React.Component {
  render() {
    const {
      onTagListUpdate,
      onEditTag,
      onArchiveTagClick,
      handleOpenAddTagDialog,
      tags,
      tagTypes,
      includeArchived,
      classes,
    } = this.props;
    const sortedTagTypes = sortBy(filter(tagTypes, (tagType) => includeArchived || !tagType.archived), 'id');

    return (
      <Grid item xs={12}>
        {
          sortedTagTypes.map((tagType) => (
            <Card key={`tag-type-card-${tagType.id}`}>
              <Grid item container className={classes.gridItem} key={tagType.id}>
                <Grid item xs={12} md={6}>
                  <CardContent>
                    <TagTypeEditor
                      className={classes.item}
                      tagType={tagType}
                    />
                  </CardContent>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  className={classes.tagContainer}
                >
                  <CardContent className={classes.flex}>
                    <TagTree
                      style={{
                        height: '100%',
                        width: '100%',
                        display: 'none',
                      }}
                      className={classes.item}
                      tags={tags}
                      tagTypes={tagTypes}
                      tagType={tagType}
                      includeArchived={includeArchived}
                      onEditTag={onEditTag}
                      onArchiveTagClick={onArchiveTagClick}
                      onTagListUpdate={onTagListUpdate}
                      handleOpenAddTagDialog={handleOpenAddTagDialog}
                    />
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          ))
        }
      </Grid>
    );
  }
}

TagTypeListComponent.propTypes = {
  onTagListUpdate: PropTypes.func,
  onEditTag: PropTypes.func,
  onArchiveTagClick: PropTypes.func,
  handleOpenAddTagDialog: PropTypes.func,
  tagTypes: PropTypes.array,
  tags: PropTypes.array,
  includeArchived: PropTypes.bool,
  classes: PropTypes.object,
};

TagTypeListComponent.defaultProps = {
  onTagListUpdate: () => {},
  onEditTag: () => {},
  onArchiveTagClick: () => {},
  handleOpenAddTagDialog: () => {},
  tagTypes: [],
  tags: [],
  includeArchived: false,
  classes: {},
};

export default withStyles(styles)(TagTypeListComponent);
